import { render, staticRenderFns } from "./NsHeader.vue?vue&type=template&id=169837c8&scoped=true&"
import script from "./NsHeader.vue?vue&type=script&lang=js&"
export * from "./NsHeader.vue?vue&type=script&lang=js&"
import style0 from "./NsHeader.vue?vue&type=style&index=0&id=169837c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169837c8",
  null
  
)

export default component.exports